export default __webpack_public_path__ + "static/media/NewCaseSelectorPopupImage.480b95b2.png";